import { render, staticRenderFns } from "./CommodityOrder.vue?vue&type=template&id=0a1ad3f1&scoped=true"
import script from "./CommodityOrder.vue?vue&type=script&lang=js"
export * from "./CommodityOrder.vue?vue&type=script&lang=js"
import style0 from "./CommodityOrder.vue?vue&type=style&index=0&id=0a1ad3f1&prod&scoped=true&lang=scss"
import style1 from "./CommodityOrder.vue?vue&type=style&index=1&id=0a1ad3f1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a1ad3f1",
  null
  
)

export default component.exports